import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  paginationSelectorWrapper: {
    display: 'flex',
    width: 268,
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginRight: 4,
    '& label': {
      color: '#513628',
      marginRight: 8,
      fontSize: 14,
      flexWrap: 'nowrap'
    },
    '& select': {
      width: 48,
      height: 24,
      borderRadius: 4,
      outline: 0,
      border: '1px solid #513628',
    },
  },
}))
